module.exports = {
	"version": "0.18.4"
};


//////////////////
// WEBPACK FOOTER
// ./~/truffle-blockchain-utils/~/web3/lib/version.json
// module id = 1219
// module chunks = 0